// Mock data for Hog Tide Fishing clone. Replace with backend API later (see contracts.md).

export const HOG = "https://hogtidefishing.com/wp-content/uploads/2026/01";

// Reliable images. NOTE: hogtidefishing.com (HOG) hotlinks are blocked by Cloudflare
// (net::ERR_BLOCKED_BY_ORB) so all HOG images were replaced with self-served customer
// assets and stable stock. Keep HOG defined only for any legacy reference.
const _CA = "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts";
export const IMG = {
  catchCouple: `${_CA}/362i5yrd_image.png`,
  sunset: "https://images.unsplash.com/photo-1652626076133-22a4ac122141?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sunsetBoat: `${_CA}/zghyjrf5_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%282%29.jpeg`,
  surfer: "https://images.unsplash.com/photo-1600966652965-a6094f4e02ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  surfer2: "https://images.unsplash.com/photo-1602882265184-473ec5d49a4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  whale: "https://images.unsplash.com/photo-1568430462989-44163eb1752f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};


export const site = {
  name: "Hog Tide Fishing",
  logo: "/hogtide-logo.png",
  phone: "+505 7654 3684",
  phoneRaw: "+50576543684",
  whatsapp: "50576543684",
  email: "Info@hogtidefishing.com",
  location: "San Juan del Sur, Nicaragua",
  tagline: "Your Offshore & Fishing Adventures Start Here",
  hp: "Twin Yamaha 250 HP engines · 500 HP total · up to 12 guests",
  whatsappNote: "We usually reply within minutes on WhatsApp · 6 AM – 8 PM daily",
  social: {
    facebook: "https://www.facebook.com/hogtidefishing",
    instagram: "https://instagram.com",
    google: "https://maps.app.goo.gl/MTxjigLSwSNzS4cH9",
  },
};

export const nav = [
  { label: "Home", to: "/" },
  {
    label: "Trips",
    to: "/trips",
    children: [
      { label: "Half Day Tour", to: "/trips/half-day-tour" },
      { label: "Full Day Inshore", to: "/trips/full-day-inshore" },
      { label: "Full Day Offshore", to: "/trips/full-day-offshore" },
      { label: "Surf Drops", to: "/trips/surf-drops" },
      { label: "Sunset Cruise", to: "/trips/sunset-cruise" },
      { label: "Whale Watching", to: "/trips/whale-watching" },
      { label: "Half Day Bottom Fishing", to: "/trips/half-day-bottom" },
      { label: "Grouper Fishing Trip", to: "/trips/grouper-fishing-trip" },
    ],
  },
  {
    label: "Fishing",
    to: "/san-juan-del-sur-fishing",
    children: [
      { label: "San Juan del Sur Fishing", to: "/san-juan-del-sur-fishing" },
      { label: "Offshore Species", to: "/offshore-species" },
      { label: "Inshore Species", to: "/inshore-species" },
      { label: "Bottom Species", to: "/bottom-species" },
      { label: "Fishing Calendar", to: "/fishing-calendar" },
      { label: "Marine Weather", to: "/weather" },
      { label: "All Species", to: "/species" },
    ],
  },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

// heroSlides is defined further below (after the photos object) so it can reuse the real catch photos.

// Set this to a real MP4/YouTube URL when the client sends the landing-page video.
export const heroVideo = null;

export const trips = [
  {
    slug: "half-day-tour",
    name: "Half Day Tour",
    hook: "Fast. Powerful. All action.",
    duration: "4 Hours",
    price: 490,
    deposit: 150,
    capacity: "Up to 12 people",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/p6jpibcf_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%286%29.jpeg",
    banner: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/r7gzwpe7_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%287%29.jpeg",
    short:
      "A 4-hour action-packed marine adventure with world-class inshore fishing, eco-tour experience and fresh sashimi onboard.",
    description:
      "Perfect for time-conscious travelers or those looking for a dynamic taste of the Pacific, the Half Day Tour is a 4-hour, action-packed marine adventure. You'll experience world-class inshore fishing for multiple species, led by our professional, high-level crew who provide all the top-tier gear and tackle. Beyond the rod, this package includes a relaxing eco-tour experience. Enjoy fresh sashimi prepared right onboard, and for a truly spectacular finish, our 2:00 PM – 6:00 PM slot offers an optional Sunset Cruise.",
    features: [
      "4 Hours of intense action",
      "Up to 12 people per trip",
      "World-class inshore fishing for multiple species",
      "Professional crew, gear & tackle included",
      "Eco tour experience",
      "Sunset Cruise option (2 PM – 6 PM slot)",
      "Dolphin & whale watching (seasonal)",
      "Fresh sashimi prepared onboard",
      "Snorkeling available on request",
    ],
  },
  {
    slug: "half-day-bottom",
    name: "Half Day Bottom Fishing Tour",
    hook: "Drop, hook up, repeat.",
    duration: "4 Hours",
    price: 490,
    deposit: 150,
    capacity: "Up to 12 people",
    image: "https://images.unsplash.com/photo-1523585559758-0a4a68774f35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    banner: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/ar8vhyzz_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%284%29.jpeg",
    short:
      "A 4-hour bottom-fishing adventure targeting grouper, snapper and other hard-pulling reef species over the rock and structure of San Juan del Sur.",
    description:
      "Our Half Day Bottom Fishing Tour is a 4-hour trip built around the rocky reefs, ledges and structure just off San Juan del Sur — home to grouper, Pacific red snapper, amberjack, parrotfish and flounder. You'll drop live and cut baits or jigs straight down to the strike zone and hang on as these powerful bottom dwellers bulldog for cover. It's non-stop action, perfect for families, first-timers and anyone who loves steady bites and a cooler full of the best-eating fish in the Pacific. All top-tier gear, tackle, bait, licenses and expert crew are included, plus fresh sashimi prepared onboard. Ask about our dedicated Grouper Fishing Trip.",
    features: [
      "4 Hours of bottom-fishing action",
      "Up to 12 people per trip",
      "Target grouper, red snapper, amberjack & more",
      "Great for families & first-time anglers",
      "Professional crew, gear, tackle & bait included",
      "Fishing licenses included",
      "Fresh sashimi prepared onboard",
      "Best-eating fish in the Pacific to take home",
    ],
  },
  {
    slug: "grouper-fishing-trip",
    name: "Grouper Fishing Trip",
    hook: "Wrestle the bulldog of the reef.",
    duration: "4 Hours",
    price: 490,
    deposit: 150,
    capacity: "Up to 12 people",
    image: "https://images.unsplash.com/photo-1763608611901-b619e7a18b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    banner: "https://images.unsplash.com/photo-1763608611901-b619e7a18b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    short:
      "A dedicated 4-hour grouper fishing trip working the rocky reefs, ledges and wrecks off San Juan del Sur for broomtail and gulf grouper — the hardest-pulling bottom fish in the Pacific.",
    description:
      "Our Grouper Fishing Trip is a focused 4-hour bottom-fishing mission built around one goal: putting you on trophy grouper. Off San Juan del Sur, broomtail and gulf grouper hold tight to rocky structure, ledges and wrecks, ambushing live and cut baits dropped straight to the bottom. The moment a big grouper eats, it's an all-out tug-of-war as the fish bulldogs for cover — pure power and one of the most addictive bites in Nicaragua. It's ideal for anglers who want a real fight and a cooler full of premium, best-eating table fare. All top-tier rods, reels, jigs, live bait, licenses and expert crew are included, plus fresh sashimi prepared onboard. Great for families and first-timers, too — grouper bite year-round in San Juan del Sur.",
    features: [
      "4 Hours targeting trophy grouper",
      "Up to 12 people per trip",
      "Fish rocky reefs, ledges & wrecks",
      "Broomtail & gulf grouper — year-round bite",
      "Heavy bottom tackle, jigs, live bait & gear included",
      "Fishing licenses included",
      "Fresh sashimi prepared onboard",
      "Premium best-eating fish to take home",
    ],
  },
  {
    slug: "full-day-offshore",
    name: "Full Day Offshore",
    hook: "No limits. Full mission.",
    duration: "7 Hours",
    price: 690,
    deposit: 200,
    capacity: "Up to 12 people",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/jgf7pdxp_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%288%29.jpeg",
    banner: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/6cg1dcvd_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%2810%29.jpeg",
    short:
      "Our most comprehensive 7-hour experience — world-class inshore & offshore fishing for the biggest game fish, with a complimentary sunset cruise.",
    description:
      "For the dedicated angler who wants to experience the full potential of the Pacific, the Full Day Offshore package is a 7-hour commitment to the ocean. This is our most comprehensive fishing experience, combining world-class inshore and offshore fishing to chase the biggest game fish. Our high-level crew will take you further out, where the true giants roam. Everything is included, from professional crew and all gear to an extensive eco-tour. The day concludes with a complimentary Sunset Cruise, making this package the ultimate marine mission.",
    features: [
      "7 Hours of deep-sea exploration",
      "Up to 12 people per trip",
      "World-class inshore & offshore fishing",
      "Professional crew, gear & tackle included",
      "Eco tour experience",
      "Complimentary Sunset Cruise included",
      "Dolphin & whale watching (seasonal)",
      "Fresh sashimi prepared onboard",
      "Snorkeling available on request",
    ],
  },
  {
    slug: "full-day-inshore",
    name: "Full Day Inshore",
    hook: "All day on the coast.",
    duration: "7 Hours",
    price: 650,
    deposit: 200,
    capacity: "Up to 12 people",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/t92zfp6u_WhatsApp%20Image%202026-09-10%20at%2012.42.56%20%285%29.jpeg",
    banner: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/03nb6txp_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%282%29.jpeg",
    short:
      "A full 7 hours working the beaches, rocky points and reefs for roosterfish, snapper, jacks and more — the ultimate light-tackle coastal adventure.",
    description:
      "The Full Day Inshore is a 7-hour light-tackle mission built around Nicaragua's incredible coastline. Instead of running far offshore, we spend the whole day probing the beaches, rocky headlands and reef structure where the Pacific's hardest-hitting coastal predators live. This is the trip for anglers who love the visual, adrenaline-fueled action of sight-casting to trophy roosterfish, battling powerful cubera snapper around structure, and hooking jack crevalle, sierra mackerel, needlefish and barracuda one after another. It's perfect for families, all skill levels and anyone who wants non-stop bites without a long boat ride. Everything is included — professional crew, all gear and tackle, live bait, fresh sashimi onboard and an eco-tour along the shore.",
    features: [
      "7 Hours of coastal light-tackle action",
      "Up to 12 people per trip",
      "Target roosterfish, snapper, jacks, mackerel & more",
      "Professional crew, gear & tackle included",
      "Live bait & sight-casting close to shore",
      "Great for families & all skill levels",
      "Eco tour along the coastline",
      "Fresh sashimi prepared onboard",
      "Dolphin & whale watching (seasonal)",
    ],
  },
  {
    slug: "surf-drops",
    name: "Surf Drops",
    hook: "Skip the roads. Hit the waves.",
    duration: "Half or Full Day",
    price: 490,
    priceFull: 690,
    deposit: 150,
    capacity: "Up to 12 people",
    image: IMG.surfer,
    banner: IMG.surfer2,
    short:
      "Fast, comfortable, direct boat access to three famous surf beaches — with world-class fishing along the way.",
    description:
      "Forget the long, bumpy drives to crowded breaks. Our Surf Drops package is the ultimate solution for surfers looking for fast, comfortable, and direct access to the best swells of the Nicaraguan Pacific. We'll provide swift offshore transportation right to three famous surf beaches. Our boats are equipped with surfboard racks, and for the downtime between sessions, you'll still have world-class fishing opportunities along the way. Stay fueled with fresh sashimi prepared on the ride.",
    features: [
      "Boat access to 3 famous surf beaches",
      "Fast and reliable offshore transport",
      "Surfboard racks on board",
      "World-class fishing opportunities along the route",
      "Fresh sashimi prepared onboard",
      "Up to 12 people per trip",
      "Half Day $490 | Full Day $690",
    ],
  },
  {
    slug: "sunset-cruise",
    name: "Sunset Cruise",
    hook: "Golden hour on the Pacific.",
    duration: "2 Hours",
    price: 350,
    deposit: 100,
    capacity: "Up to 12 people",
    image: IMG.sunset,
    banner: IMG.sunset,
    short:
      "Relax and enjoy a peaceful cruise as the sun sets over the Pacific. Ideal for couples, groups and special occasions.",
    description:
      "Relax and enjoy a peaceful cruise as the sun sets over the Pacific Ocean. Ideal for couples, groups, and special occasions, the Sunset Cruise pairs great music, cold drinks and the calm open water for an unforgettable golden-hour experience aboard the Hog Tide.",
    features: [
      "Approx. 2 hours golden-hour cruise",
      "Up to 12 people per trip",
      "Great speakers & good vibes",
      "Cold drinks onboard",
      "Perfect for couples & celebrations",
      "Dolphin & whale watching (seasonal)",
    ],
  },
  {
    slug: "whale-watching",
    name: "Whale Watching",
    hook: "Giants of the Pacific.",
    duration: "3 Hours",
    price: 450,
    deposit: 150,
    capacity: "Up to 12 people",
    image: IMG.whale,
    banner: IMG.whale,
    short:
      "A 3-hour ocean safari off San Juan del Sur to spot humpback whales, dolphins, sea turtles and rays during the Pacific migration season.",
    description:
      "Between July and October, the warm Pacific waters off San Juan del Sur come alive with migrating humpback whales, playful pods of dolphins, sea turtles and rays. Our Whale Watching trip is a 3-hour guided ocean safari aboard the Hog Tide, run at a respectful, wildlife-first distance so you can witness breaching whales and tail-slaps up close without disturbing them. Perfect for families, photographers and nature lovers, the trip includes our professional crew, safety gear, fresh water and cold drinks onboard, plus plenty of scenic coastline. Sightings are seasonal and never guaranteed — but San Juan del Sur is one of Nicaragua's best spots to see these gentle giants.",
    features: [
      "Approx. 3 hours guided ocean safari",
      "Up to 12 people per trip",
      "Humpback whales, dolphins, turtles & rays (seasonal)",
      "Best July – October during migration",
      "Respectful, wildlife-first viewing distance",
      "Professional crew & safety gear included",
      "Cold drinks & fresh water onboard",
      "Great for families, kids & photographers",
    ],
  },
];

const U = (id, extra = "") =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200${extra}`;

export const species = [
  // ---- Bottom Fishing ----
  {
    slug: "grouper",
    name: "Grouper",
    latin: "Mycteroperca xenarcha",
    zone: "bottom",
    peak: "Year-round",
    weight: "15–60 lbs",
    method: "Bottom fishing / Live bait",
    image: "https://images.unsplash.com/photo-1763608611901-b619e7a18b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    blurb:
      "The bulldog of the reef. Broomtail and gulf grouper hold tight to rocky structure and wrecks off San Juan del Sur, hammering live baits and jigs dropped to the bottom. Powerful, dogged fighters and outstanding table fare — a favorite target on our Grouper Fishing Trip.",
  },
  {
    slug: "red-snapper",
    name: "Red Snapper",
    latin: "Lutjanus peru",
    zone: "bottom",
    peak: "Year-round",
    weight: "5–25 lbs",
    method: "Bottom fishing / Cut & live bait",
    image: "https://images.pexels.com/photos/7001662/pexels-photo-7001662.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    blurb:
      "Pacific red snapper (pargo / huachinango) are a San Juan del Sur bottom-fishing staple — bright red, hard-pulling and among the best-eating fish in the ocean. Caught steadily year-round over reef and rock.",
  },
  {
    slug: "amberjack",
    name: "Amberjack",
    latin: "Seriola rivoliana",
    zone: "bottom",
    peak: "Year-round",
    weight: "15–60 lbs",
    method: "Bottom fishing / Jigging / Live bait",
    image: "https://images.pexels.com/photos/38301121/pexels-photo-38301121.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    blurb:
      "Pound-for-pound one of the hardest-pulling fish in the Pacific. Almaco amberjack school over deep reefs and pinnacles off San Juan del Sur, crushing jigs and live baits and testing your arms on every drop — a bucket-list bottom-fishing brawler.",
  },
  {
    slug: "parrotfish",
    name: "Parrotfish",
    latin: "Scarus ghobban",
    zone: "bottom",
    peak: "Year-round",
    weight: "3–15 lbs",
    method: "Bottom fishing / Light tackle",
    image: "https://images.pexels.com/photos/3684932/pexels-photo-3684932.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    blurb:
      "Vividly colored reef dwellers with powerful beaks, parrotfish are a fun, family-friendly light-tackle target over the shallow rock and reef of San Juan del Sur — beautiful to catch and a great intro to bottom fishing.",
  },
  {
    slug: "flounder",
    name: "Flounder",
    latin: "Paralichthys woolmani",
    zone: "bottom",
    peak: "Year-round",
    weight: "2–12 lbs",
    method: "Bottom fishing / Sandy bottom",
    image: "https://images.pexels.com/photos/29755542/pexels-photo-29755542.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    blurb:
      "Masters of camouflage on the sandy bottom, Pacific flounder are an exciting light-tackle bottom species and prized eating — a great change-of-pace target on a half-day bottom fishing trip off San Juan del Sur.",
  },
  // ---- Offshore ----
  {
    slug: "sailfish",
    name: "Sailfish",
    latin: "Istiophorus platypterus",
    zone: "offshore",
    peak: "Dec – Apr",
    weight: "80–120 lbs",
    method: "Trolling / Live bait",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Istiophorus_platypterus_101956558.jpg/960px-Istiophorus_platypterus_101956558.jpg",
    blurb:
      "Nicaragua's signature billfish. Famous for explosive aerial acrobatics and blistering runs — multiple hookups per trip are common in peak season. All sailfish are catch-and-release.",
  },
  {
    slug: "blue-marlin",
    name: "Blue Marlin",
    latin: "Makaira nigricans",
    zone: "offshore",
    peak: "May – Sep",
    weight: "200–500 lbs",
    method: "Trolling / Live bait",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/jgf7pdxp_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%288%29.jpeg",
    blurb:
      "The ultimate trophy fish of the Pacific. Some of the largest blue marlin pass through these waters during the green season — a true bucket-list species for any serious angler.",
  },
  {
    slug: "black-marlin",
    name: "Black Marlin",
    latin: "Istiompax indica",
    zone: "offshore",
    peak: "Jul – Sep",
    weight: "300–700 lbs",
    method: "Trolling / Live bait",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Istiompax_indica.jpg/960px-Istiompax_indica.jpg",
    blurb:
      "One of the largest and most powerful billfish in the world. Less common than blue marlin but potentially larger — specimens over 1,000 lbs have been recorded in Pacific waters.",
  },
  {
    slug: "yellowfin-tuna",
    name: "Yellowfin Tuna",
    latin: "Thunnus albacares",
    zone: "offshore",
    peak: "May – Nov",
    weight: "50–200 lbs",
    method: "Chunking / Popping",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Yellowfin_tuna_nurp.jpg/960px-Yellowfin_tuna_nurp.jpg",
    blurb:
      "One of the hardest-fighting fish in the ocean. Available year-round with the largest schools forming May through November around temperature breaks and weed lines offshore.",
  },
  {
    slug: "mahi-mahi",
    name: "Mahi-Mahi (Dorado)",
    latin: "Coryphaena hippurus",
    zone: "offshore",
    peak: "Year-Round",
    weight: "10–40 lbs",
    method: "Trolling / Casting",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/6cg1dcvd_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%2810%29.jpeg",
    blurb:
      "Brilliantly colored and acrobatic. Abundant year-round around weed lines and floating debris. One of the best table fish in the ocean and a guaranteed hit on any charter.",
  },
  {
    slug: "wahoo",
    name: "Wahoo",
    latin: "Acanthocybium solandri",
    zone: "offshore",
    peak: "May – Nov",
    weight: "30–70 lbs",
    method: "High-speed trolling",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Acanthocybium_solandri_%28Cuvier%2C_1832%29.jpg/1280px-Acanthocybium_solandri_%28Cuvier%2C_1832%29.jpg",
    blurb:
      "Lightning-fast with razor-sharp teeth — one of the fastest fish in the ocean, capable of speeds over 60 mph. A prized catch and excellent table fare.",
  },
  // ---- Inshore ----
  {
    slug: "roosterfish",
    name: "Roosterfish",
    latin: "Nematistius pectoralis",
    zone: "inshore",
    peak: "May – Oct",
    weight: "20–80 lbs",
    method: "Live bait / Casting",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/v950tkt7_image.png",
    blurb:
      "The most iconic inshore species in the Pacific. Named for its spectacular comb-like dorsal fin. Found along beaches and rocky points — the star of our half-day inshore charters.",
  },
  {
    slug: "cubera-snapper",
    name: "Cubera Snapper",
    latin: "Lutjanus cyanopterus",
    zone: "inshore",
    peak: "Jun – Oct",
    weight: "10–40 lbs",
    method: "Bottom fishing / Jigging",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Gfp-cubera-snapper.jpg/960px-Gfp-cubera-snapper.jpg",
    blurb:
      "A powerful reef fish with crushing jaws and brute strength. Cubera snapper lurk around rocky points and reef structure along the coastline. Excellent table fare and a tough fighter.",
  },
  {
    slug: "jack-crevalle",
    name: "Jack Crevalle",
    latin: "Caranx hippos",
    zone: "inshore",
    peak: "Year-Round",
    weight: "5–20 lbs",
    method: "Casting / Trolling",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/f1keehg9_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%286%29.jpeg",
    blurb:
      "An aggressive, hard-fighting schooling fish found year-round along the coast. Known for explosive strikes and powerful runs — great fun on light tackle for all skill levels.",
  },
  {
    slug: "sierra-mackerel",
    name: "Sierra Mackerel",
    latin: "Scomberomorus sierra",
    zone: "inshore",
    peak: "Year-Round",
    weight: "3–12 lbs",
    method: "Casting / Trolling",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Scomberomorus_sierra_Ecuador.jpg/960px-Scomberomorus_sierra_Ecuador.jpg",
    blurb:
      "Fast, acrobatic and abundant along coastal waters. A fantastic target on light tackle — they strike hard and make blistering runs that test even experienced anglers.",
  },
  {
    slug: "needlefish",
    name: "Needlefish",
    latin: "Tylosurus crocodilus",
    zone: "inshore",
    peak: "May – Oct",
    weight: "2–8 lbs",
    method: "Surface casting",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Tylosurus_crocodilus.jpg/960px-Tylosurus_crocodilus.jpg",
    blurb:
      "A long, slender surface predator. Needlefish are spectacular jumpers when hooked — their acrobatic aerial displays make them a crowd favorite on family inshore charters.",
  },
  {
    slug: "barracuda",
    name: "Barracuda",
    latin: "Sphyraena barracuda",
    zone: "inshore",
    peak: "Year-Round",
    weight: "5–25 lbs",
    method: "Casting / Trolling",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Barracuda_laban.jpg/960px-Barracuda_laban.jpg",
    blurb:
      "A toothy ambush predator found around structure and drop-offs. Aggressive strikes and fast runs make barracuda an exciting light-tackle target close to shore.",
  },
];

export const calendarMonths = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
// P = Peak, G = Good, O = Off
export const calendar = [
  { group: "Offshore Species" },
  { name: "Sailfish", m: ["P","P","P","P","G","G","O","O","O","G","P","P"] },
  { name: "Blue Marlin", m: ["O","O","G","G","P","P","P","P","G","O","O","O"] },
  { name: "Black Marlin", m: ["O","O","O","O","G","G","P","P","P","G","O","O"] },
  { name: "Striped Marlin", m: ["P","P","P","G","O","O","O","O","O","P","P","P"] },
  { name: "Yellowfin Tuna", m: ["G","G","G","G","P","P","P","P","P","P","G","G"] },
  { name: "Mahi-Mahi (Dorado)", m: ["G","G","G","G","P","P","P","P","P","P","P","G"] },
  { name: "Wahoo", m: ["P","P","P","G","P","P","P","P","P","G","G","O"] },
  { name: "Bonito", m: ["G","G","G","G","P","P","P","P","G","G","G","G"] },
  { group: "Inshore & Reef Species" },
  { name: "Roosterfish", m: ["G","G","G","P","P","P","P","P","P","O","O","G"] },
  { name: "Cubera Snapper", m: ["G","G","G","G","G","P","P","P","P","P","P","G"] },
  { name: "Red Snapper", m: ["G","G","G","G","P","P","P","P","P","G","G","G"] },
  { name: "Grouper", m: ["G","G","G","G","P","P","P","P","P","G","G","G"] },
  { name: "Jack Crevalle", m: ["G","G","G","G","P","P","P","P","P","G","G","G"] },
  { name: "Sierra Mackerel", m: ["G","G","G","G","P","P","P","P","P","G","G","G"] },
  { name: "Barracuda", m: ["G","G","G","G","P","P","P","P","P","G","G","G"] },
  { name: "Needlefish", m: ["O","O","G","G","P","P","P","P","G","G","O","O"] },
];

const A = "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts";
// Real Hog Tide catch photos
export const photos = {
  jack: `${A}/onlbyhod_WhatsApp%20Image%202026-09-10%20at%2012.43.02%20%284%29.jpeg`,
  needlefishLong: `${A}/yshxvq3r_WhatsApp%20Image%202026-09-10%20at%2012.43.02%20%283%29.jpeg`,
  needlefishOpen: `${A}/0ylz00mn_WhatsApp%20Image%202026-09-10%20at%2012.43.02.jpeg`,
  mixCatch: `${A}/nnrny4ml_WhatsApp%20Image%202026-09-10%20at%2012.43.02%20%282%29.jpeg`,
  goodVibes: `${A}/xwb39200_WhatsApp%20Image%202026-09-10%20at%2012.43.02%20%281%29.jpeg`,
  roosterfish: `${A}/v950tkt7_image.png`,
  jackHero: `${A}/f1keehg9_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%286%29.jpeg`,
  mahi: `${A}/r7gzwpe7_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%287%29.jpeg`,
  needlefishPair: `${A}/e3cds8l9_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%2810%29.jpeg`,
  needlefishPopper: `${A}/cogu0y15_WhatsApp%20Image%202026-09-10%20at%2012.43.01%20%286%29.jpeg`,
  needlefishTeeth: `${A}/03jmk73r_WhatsApp%20Image%202026-09-10%20at%2012.43.01%20%289%29.jpeg`,
  captain: `${A}/2odaq8gu_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%285%29.jpeg`,
  mascots: `${A}/hj8sibmh_WhatsApp%20Image%202026-09-10%20at%2012.43.00%20%282%29.jpeg`,
  cap: `${A}/usk2z6fm_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%283%29.jpeg`,
  sashimi: `${A}/ar8vhyzz_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%284%29.jpeg`,
  beachTona: `${A}/21z8mrn6_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%286%29.jpeg`,
  doradoWoman: `${A}/mjn2jsbv_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%287%29.jpeg`,
  doradoCouple: `${A}/zghyjrf5_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%282%29.jpeg`,
  captainHelm: `${A}/gqrbomfv_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%287%29.jpeg`,
  gearRack: `${A}/boycasg0_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%289%29.jpeg`,
  jackShirtless: `${A}/p6jpibcf_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%286%29.jpeg`,
  jackWoman: `${A}/qgowjpzx_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%285%29.jpeg`,
  roosterCoast: `${A}/zghyjrf5_WhatsApp%20Image%202026-09-10%20at%2012.42.59%20%282%29.jpeg`,
  roosterBeard: `${A}/t92zfp6u_WhatsApp%20Image%202026-09-10%20at%2012.42.56%20%285%29.jpeg`,
  needlefishSombrero: `${A}/dfrz1n1r_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%284%29.jpeg`,
  marlin: `${A}/jgf7pdxp_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%288%29.jpeg`,
  doradoShirtless: `${A}/6cg1dcvd_WhatsApp%20Image%202026-09-10%20at%2012.42.57%20%2810%29.jpeg`,
  actionRock: `${A}/03nb6txp_WhatsApp%20Image%202026-09-10%20at%2012.42.58%20%282%29.jpeg`,
};

// Landing-page hero slideshow — only high-quality, well-framed photos so every slide fills the hero cleanly.
export const heroSlides = [
  { img: photos.actionRock, label: "Fish On — San Juan del Sur" },
  { img: photos.captainHelm, label: "Your Pro Crew at the Helm", cls: "object-[74%_50%] md:object-center" },
  { img: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/loegh5dm_image.png", label: "Trophy Roosterfish", pos: "50% 32%" },
  { img: photos.doradoShirtless, label: "Fast. Powerful. All Action." },
  { img: photos.jackShirtless, label: "Hard-Hitting Coastal Battles" },
  { img: IMG.catchCouple, label: "Private Charters for Everyone" },
  { img: photos.roosterBeard, label: "Roosterfish of a Lifetime" },
  { img: IMG.sunset, label: "Unforgettable Pacific Sunsets" },
  { img: IMG.sunsetBoat, label: "Golden-Hour Cruises" },
];

// Landscape-only images for wide PAGE HEADERS & CTA bands (decoupled from the home slideshow,
// which uses portrait action shots). Guarantees headers fit properly on mobile & desktop.
export const heroImages = [
  { img: photos.doradoShirtless }, // 0
  { img: photos.captainHelm },     // 1
  { img: photos.jackShirtless },   // 2
  { img: IMG.catchCouple },        // 3
  { img: IMG.sunsetBoat },         // 4
];

// Recent trophy catches for the rotating "Catch of the Week" feature. Photos are real, verified Hog Tide catches.
export const featuredCatches = [
  {
    species: "Blue Marlin",
    img: photos.marlin,
    caption: "A giant blue marlin brought boatside offshore — the ultimate Pacific trophy.",
    zone: "Offshore",
    trip: "/trips/full-day-offshore",
  },
  {
    species: "Roosterfish",
    img: photos.roosterBeard,
    caption: "Trophy roosterfish sight-cast right along the coast — the crown jewel of our inshore days.",
    zone: "Inshore",
    trip: "/trips/full-day-inshore",
  },
  {
    species: "Mahi-Mahi (Dorado)",
    img: photos.doradoShirtless,
    caption: "A vibrant, hard-fighting dorado — one of the most beautiful fish in the sea.",
    zone: "Offshore",
    trip: "/trips/full-day-offshore",
  },
  {
    species: "Jack Crevalle",
    img: photos.jackHero,
    caption: "Powerful jack crevalle landed close to shore — non-stop bites all day long.",
    zone: "Inshore",
    trip: "/trips/full-day-inshore",
  },
];

export const gallery = [
  { src: "/gallery/catch-mahi-crew.jpg", tall: false, cat: "Offshore" },
  { src: "/gallery/beach-tuna-crew.jpg", tall: false, cat: "Offshore" },
  { src: "/gallery/hogtide-horse.jpg", tall: false, cat: "Life Aboard" },
  { src: photos.marlin, tall: false, cat: "Offshore" },
  { src: photos.actionRock, tall: true, cat: "Inshore" },
  { src: photos.roosterBeard, tall: true, cat: "Roosterfish" },
  { src: photos.doradoShirtless, tall: false, cat: "Offshore" },
  { src: photos.jackShirtless, tall: false, cat: "Inshore" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/2ou3egkl_image.png", tall: false, cat: "Inshore" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/ts9pwokq_image.png", tall: false, cat: "Inshore" },
  { src: "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/lgki0ahd_image.png", tall: false, cat: "Inshore" },
  { src: photos.gearRack, tall: true, cat: "Life Aboard" },
  { src: photos.captainHelm, tall: false, cat: "Life Aboard" },
  { src: photos.jackWoman, tall: true, cat: "Inshore" },
  { src: photos.needlefishSombrero, tall: false, cat: "Inshore" },
  { src: photos.sashimi, tall: false, cat: "Life Aboard" },
  { src: photos.beachTona, tall: true, cat: "Offshore" },
  { src: photos.cap, tall: false, cat: "Life Aboard" },
  { src: photos.jackHero, tall: true, cat: "Inshore" },
  { src: photos.mascots, tall: false, cat: "Life Aboard" },
  { src: photos.roosterfish, tall: true, cat: "Roosterfish" },
  { src: IMG.sunset, tall: false, cat: "Scenery" },
  { src: IMG.catchCouple, tall: false, cat: "Offshore" },
  { src: IMG.whale, tall: false, cat: "Whales" },
  { src: IMG.surfer, tall: false, cat: "Surf" },
  { src: IMG.surfer2, tall: false, cat: "Surf" },
  { src: U("1562791681-bd6aecadf861"), tall: false, cat: "Scenery" },
  // Bottom fishing targets — so bottom-fishing fans can find their fish
  { src: "https://images.unsplash.com/photo-1763608611901-b619e7a18b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tall: false, cat: "Bottom Fishing" },
  { src: "https://images.pexels.com/photos/7001662/pexels-photo-7001662.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", tall: true, cat: "Bottom Fishing" },
  { src: "https://images.pexels.com/photos/38301121/pexels-photo-38301121.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", tall: false, cat: "Bottom Fishing" },
  { src: "https://images.pexels.com/photos/3684932/pexels-photo-3684932.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200", tall: false, cat: "Bottom Fishing" },
];

// Gallery filter categories (order controls the chip row). "All" is prepended in the UI.
export const galleryCategories = ["Offshore", "Inshore", "Bottom Fishing", "Roosterfish", "Whales", "Surf", "Life Aboard", "Scenery"];

export const testimonials = [
  { name: "Ellery Doyna", rating: 5, text: "We had a blast today, it is very similar to fishing charters in America. They have great speakers, great guides and take you to the best spots." },
  { name: "Towns Wiley", rating: 5, text: "We went on a short afternoon cruise and had a great time. Larry was great and the gear was handled efficiently. A few rain showers were in the area and Hogtide expertly avoided all of them." },
  { name: "Phill Pesenti", rating: 5, text: "I've gone several times on the Hogtide over the last decade and I always have a blast. The best crew, good vibes and always feel safe. I recommend to anyone who wants to go fishing or wants a private booze cruise to a remote beach." },
  { name: "Jess López", rating: 5, text: "Great experience, I got to know several beaches in the open water, saw whales, I enjoyed a lot with my friends, excellent music, fishing and unforgettable sunsets." },
];

export const faqs = [
  { q: "Where do trips depart from?", a: "All Hog Tide charters depart from San Juan del Sur on Nicaragua's Pacific coast. We'll confirm the exact meeting point and time when you book." },
  { q: "What is the best time to fish in San Juan del Sur?", a: "There is no bad time — fishing is world-class year-round. Sailfish peak December–April, while blue & black marlin and giant yellowfin tuna arrive May–September. Roosterfish inshore action is best May–October." },
  { q: "Are sailfish and marlin catch-and-release?", a: "Yes. Billfish are catch-and-release by tradition and conservation. Tuna, mahi-mahi, wahoo, roosterfish and snapper can be kept and filleted by the crew at the end of your trip." },
  { q: "How many people can join a trip?", a: "Every Hog Tide charter is private with capacity for up to 12 guests. You only ever share the boat with your own crew." },
  { q: "Is gear and tackle included?", a: "Absolutely. All top-tier rods, reels, tackle, bait and a professional crew are included in every package, along with fresh sashimi prepared onboard." },
  { q: "How do I reserve my date?", a: "Hit any 'Leave a Deposit' button to secure your date with a small deposit via PayPal or Stripe. The balance is settled on the day of your trip." },
  { q: "Can beginners fish with you?", a: "Yes! Our crew loves teaching first-timers and families. Trips are tailored around your goals and experience level." },
  { q: "Do you offer dolphin and whale watching?", a: "Seasonally, yes — dolphins are common year-round and humpback whales pass through the region. We also offer snorkeling on request." },
];

export const blog = [
  {
    slug: "best-time-fishing-san-juan-del-sur",
    title: "The Best Time to Go Fishing in San Juan del Sur, Nicaragua",
    date: "2025-06-18",
    author: "Hog Tide Crew",
    tag: "Seasons",
    cover: "https://images.unsplash.com/photo-1569879925512-85ee9bf5c538?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt: "Sailfish in winter, marlin and tuna in the green season, roosterfish all summer — here's how to plan the perfect fishing trip in San Juan del Sur.",
    body: [
      "San Juan del Sur sits on one of the most productive stretches of the Central American Pacific, which means there is genuinely no bad time to drop a line. That said, knowing what runs when will help you target the fish of your dreams.",
      "December through April is the legendary dry season: blue water, calm seas and the highest concentrations of sailfish of the year. Multiple hookups per trip are the norm and conditions are ideal for first-time offshore anglers.",
      "From May through September the green season transforms the offshore grounds. Blue and black marlin arrive in force alongside massive yellowfin tuna schools, mahi-mahi and wahoo — some of the biggest fish of the year are caught in these months.",
      "Inshore, roosterfish action peaks May through October along the beaches and rocky points, with cubera snapper and jack crevalle firing at the same time. Whatever month you visit, a private Hog Tide charter puts you on the fish.",
    ],
  },
  {
    slug: "roosterfish-san-juan-del-sur-guide",
    title: "Chasing Roosterfish: The Ultimate San Juan del Sur Inshore Guide",
    date: "2025-06-02",
    author: "Hog Tide Crew",
    tag: "Species",
    cover: "https://cdn.pixabay.com/photo/2016/08/25/17/27/rooster-fish-1620131_640.jpg",
    excerpt: "With its unmistakable comb-like dorsal fin and bulldog fight, the roosterfish is the crown jewel of Nicaraguan inshore fishing. Here's how we target them.",
    body: [
      "Few fish get an angler's heart racing like a big roosterfish charging a live bait in the shallows. Found along the beaches and rocky points of San Juan del Sur, roosters are pure adrenaline on light tackle.",
      "We target them with live bait and casting techniques close to structure, usually on our Half Day Tour. Peak season runs May through October when fish in the 20–80 lb range patrol the coast.",
      "Roosterfish are almost always released — they're prized as a sport fish, not table fare. Bring a camera: the classic hero shot of that spiked dorsal fin fanned out is worth the trip alone.",
    ],
  },
  {
    slug: "offshore-vs-inshore-nicaragua",
    title: "Offshore vs Inshore Fishing in Nicaragua: Which Trip Is Right for You?",
    date: "2025-05-20",
    author: "Hog Tide Crew",
    tag: "Guides",
    cover: "https://images.unsplash.com/photo-1625183656263-171183307b15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt: "Big blue-water billfish or hard-hitting coastal predators? We break down the difference so you can pick the perfect Hog Tide charter.",
    body: [
      "Offshore fishing takes you miles out into the deep blue in search of billfish, tuna, dorado and wahoo. It's the choice for anglers chasing a trophy and the raw power of open-ocean game fish — best experienced on our Full Day Offshore package.",
      "Inshore fishing stays closer to the dramatic coastline, targeting roosterfish, snapper, jack crevalle and mackerel around beaches and rocky points. It's action-packed, great for families, and perfect for a Half Day Tour.",
      "On a full-day charter we can often combine both — start inshore at first light, then push offshore as conditions allow. Tell us what you want to catch and we'll build the day around it.",
    ],
  },
];

export const paymentMethods = [
  { id: "paypal", label: "PayPal", note: "Fast & secure checkout" },
  { id: "stripe", label: "Credit / Debit Card", note: "Powered by Stripe" },
];
